export default "__VITE_ASSET__e2f96317__"